<ng-container *transloco="let t; read: 'ACCOUNT_CHANGE_PASSWORD_MODAL_COMPONENT'">
  <ion-toolbar>
    <div class="toolbar-header">
      <ion-button (click)="dismissModal()" fill="none" color="secondary">
        <ion-icon slot="icon-only" name="arrow-back-outline"></ion-icon>
      </ion-button>
      <h1>{{ t('TITLE') }}</h1>
      <div class="right"></div>
    </div>
  </ion-toolbar>

  <ion-content class="ion-padding">
    <form class="mx-32-desktop" [formGroup]="form" (submit)="onSubmit()" autocomplete="off">
      <h3>{{ t('EDIT_PASSWORD') }}</h3>

      <ion-input formControlName="email" class="hide" [autocomplete]="'username'"> </ion-input>

      <app-password formControlName="oldPassword" [label]="t('OLD_PASSWORD')"></app-password>

      <app-password [isNewPassword]="true" formControlName="newPassword" [withValidators]="true" [label]="t('NEW_PASSWORD')"></app-password>

      <div class="flex-column items-center mt-32 flex-desktop">
        <ion-button [disabled]="form.invalid" type="submit" color="primary" class="mt-24 self-stretch desktop-centered">
          <span>{{ t('VALIDATE') }}</span>
          <app-pre-loader *ngIf="changePasswordRequestStatus.value === 'pending'"></app-pre-loader>
        </ion-button>
        <app-error-container
          class="mt-16 fade-in self-stretch"
          *ngIf="changePasswordRequestStatus.value === 'error'"
          [errorKey]="changePasswordRequestStatus.error.errorKey"
        >
        </app-error-container>
      </div>
    </form>

    <app-debug-form *appIfDebug [formGroup]="form"></app-debug-form>
  </ion-content>
</ng-container>
